import React from 'react'
import * as Local from 'src/components/setup-provider'

export function useSetupContext() {
  return React.useContext(Local.Context)
}
